import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { INVOCATION_GRID2D__view } from '../../_invocations/grid2d/INVOCATION_GRID2D__view';
import { INVOCATION_IMAGE__trim_color } from '../../_invocations/image/INVOCATION_IMAGE__trim_color';
import { INVOCATION_IMAGE__viewport } from '../../_invocations/image/INVOCATION_IMAGE__viewport';
import { ENUM__graph_template_name } from '../sd_1/ENUM__graph_template_name';

export function GENERATION_TOOL__image_edit__trim_color() {
  /*
   *
   */

  let out = new DTO__generation_tool();
  out.name = ENUM__graph_template_name.TRIM_COLOR;

  const graph = DTO_GRAPH__instance.CREATE_NEW();
  out.graph = graph;

  /*
   * COLOR GRID2D VIEW
   */
  const node__grid2d = INVOCATION_GRID2D__view.create_node_for(graph);

  /*
   * COLOR MAP
   */

  const node__trim_color = INVOCATION_IMAGE__trim_color.create_node_for(graph);
  graph.edge__try_add_for_fields(node__trim_color.out, node__grid2d.image);

  /*
   *
   */

  const node__viewport = INVOCATION_IMAGE__viewport.CREATE_VIEWPORT_FOR(graph, node__trim_color.image);

  /*
   *
   */

  let fields__visible: FIELD__base[] = [node__viewport.image, node__trim_color.threshold];
  let field_column_id = node__trim_color.threshold.meta.field_id;

  out.view__add({ fields__visible, fields__stored: fields__visible, field_column_id });

  /*
   *
   */

  return out;
}
